import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Rocket } from "lucide-react";
import { toast } from "sonner";

export default function AdminLaunchChecklist() {
  const [data, setData] = useState(null);

  const load = () => api.get("/admin/launch-checklist").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data) return <div className="p-8" style={{ color: "#475569" }}>Loading…</div>;

  const toggle = async (item, done) => {
    try {
      await api.put("/admin/launch-checklist", { item, done });
      load();
    } catch (e) { toast.error("Could not update the checklist."); }
  };

  return (
    <div className="p-4 sm:p-8 max-w-3xl mx-auto">
      <div className="flex items-center gap-3">
        <Rocket className="w-7 h-7" style={{ color: "#0B2D59" }} />
        <h1 className="font-serif text-3xl" style={{ color: "#0B2D59" }}>Pre-launch checklist</h1>
      </div>
      <div className="mt-3 p-4 rounded-xl text-sm font-medium" data-testid="launch-ready-banner"
        style={data.ready
          ? { background: "#ECF3EC", color: "#2A4535", border: "1px solid #2A6E4F" }
          : { background: "#FDF6EC", color: "#8A6D1D", border: "1px solid #D9B45B" }}>
        {data.ready
          ? "All checks passed. The application is ready for launch."
          : "Not ready yet — complete the unchecked items below before going live."}
      </div>

      <h2 className="font-serif text-xl mt-7" style={{ color: "#0B2D59" }}>Verified automatically</h2>
      <ul className="p2p-card mt-3 divide-y" data-testid="launch-auto-list" style={{ borderColor: "#E2EBF1" }}>
        {data.auto.map((item) => (
          <li key={item.id} className="flex items-start justify-between gap-3 p-4" data-testid={`launch-auto-${item.id}`}>
            <span className="flex items-start gap-3">
              {item.done
                ? <CheckCircle2 className="w-5 h-5 mt-0.5 shrink-0" style={{ color: "#2A6E4F" }} />
                : <XCircle className="w-5 h-5 mt-0.5 shrink-0" style={{ color: "#8A2A2A" }} />}
              <span className="text-sm" style={{ color: "#0B2D59" }}>{item.label}</span>
            </span>
            <span className="text-xs font-bold shrink-0 px-2 py-0.5 rounded"
              style={item.done ? { background: "#ECF3EC", color: "#2A6E4F" } : { background: "#FBEAEA", color: "#8A2A2A" }}>
              {item.done ? "PASS" : "FAIL"}
            </span>
          </li>
        ))}
      </ul>

      <h2 className="font-serif text-xl mt-7" style={{ color: "#0B2D59" }}>Confirm manually</h2>
      <p className="text-sm" style={{ color: "#475569" }}>Check each item after you have personally verified it.</p>
      <ul className="p2p-card mt-3 divide-y" data-testid="launch-manual-list" style={{ borderColor: "#E2EBF1" }}>
        {data.manual.map((item) => (
          <li key={item.id} className="flex items-start justify-between gap-3 p-4">
            <span className="flex items-start gap-3">
              <input type="checkbox" className="mt-1" checked={item.done}
                data-testid={`launch-manual-${item.id}`}
                onChange={(e) => toggle(item.id, e.target.checked)} />
              <span>
                <span className="text-sm block" style={{ color: "#0B2D59" }}>{item.label}</span>
                {item.done && item.confirmed_by && (
                  <span className="text-xs block mt-0.5" style={{ color: "#475569" }}>
                    Confirmed by {item.confirmed_by} · {item.confirmed_at ? new Date(item.confirmed_at).toLocaleString() : ""}
                  </span>
                )}
              </span>
            </span>
            <span className="text-xs font-bold shrink-0 px-2 py-0.5 rounded"
              style={item.done ? { background: "#ECF3EC", color: "#2A6E4F" } : { background: "#FDF6EC", color: "#8A6D1D" }}>
              {item.done ? "PASS" : "NOT TESTED"}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
